export const SIGNER_EXTENSION_URL =
  'https://chrome.google.com/webstore/detail/casperlabs-signer/djhndpllfiibmcdbnmaaahkhchcoijce';
export const HOME_PATH = '/';
export const BUY_CSPR_PATH = '/buy-cspr';
export const ACCOUNT_DETAILS_PATH = '/account/:id';
export const CREATE_ACCOUNT_PATH = '/create-account';
export const SEARCH_PATH = '/search/:id';
export const CONTRACT_PATH = '/contract/:id';
export const NFT_TOKEN_PATH =
  '/contracts/:contract_package_hash/nfts/:token_id';
export const CONTRACT_PACKAGE_PATH = '/contract-package/:id';
export const BLOCK_LIST_PATH = '/blocks';
export const BLOCK_DETAILS_PATH = '/block/:id';
export const VALIDATOR_LIST_PATH = '/validators';
export const VALIDATOR_AUCTION_PATH = '/validators-auction';
export const VALIDATOR_DETAILS_PATH = '/validator/:id';
export const DEPLOY_LIST_PATH = '/deploys';
export const DEPLOY_DETAILS_PATH = '/deploy/:id';
export const TRANSACTION_LIST_PATH = '/transactions';
export const TRANSACTION_DETAILS_PATH = '/transaction/:id';
export const FAUCET_PATH = '/tools/faucet';
export const PEERS_PATH = '/tools/peers';
export const PROFILE_PATH = '/profile';
export const VIEW_ADDRESS_PATH = '/view-address';
export const DEVELOPER_TOOLS_PATH = '/developer-tools';
export const TOS_PATH = '/tos';
export const PRIVACY_POLICY_PATH = '/privacy';
export const CHANGELOG_PATH = '/changelog';
export const CREDITS_PATH = '/credits';
export const DELEGATE_STAKE_PATH = '/delegate-stake';
export const DELEGATE_STAKE_SIGN_PATH = '/delegate-stake/:deploy_hash';
export const UNDELEGATE_STAKE_PATH = '/undelegate-stake';
export const UNDELEGATE_STAKE_SIGN_PATH = '/undelegate-stake/:deploy_hash';
export const TRANSFER_CSPR_PATH = '/transfer';
export const TRANSFER_CSPR_SIGN_PATH = '/transfer/:deploy_hash';
export const UREF_PATH = '/uref/:id';
export const DICTIONARY_PATH = '/dictionary/:id';
export const CONTRACT_LIST_PATH = '/contracts';
export const ACCOUNTS_LIST_PATH = '/accounts';
export const ACTIVITY_EXPORT_PATH = '/activity-export';
export const ACTIVITY_EXPORT_SIGN_PATH = '/activity-export/:deploy_hash';
export const ACTIVITY_EXPORT_ONBOARDING_PATH = '/activity-export-onboarding';
export const ACTIVITY_EXPORT_LEARN_MORE_PATH =
  '/learn-more-about-activity-export';
export const ASSOCIATED_KEYS_ONBOARDING_PATH = '/associated-keys-onboarding';
export const ASSOCIATED_KEYS_PATH = '/associated-keys';
export const MANAGE_ASSOCIATED_KEYS_PATH = '/manage-associated-keys';
export const MANAGE_ASSOCIATED_KEYS_SIGN_PATH =
  '/manage-associated-keys/:deploy_hash';
export const ASSOCIATED_KEYS_LEARN_MORE_PATH =
  '/learn-more-about-associated-keys';
export const PURCHASE_NFT_PATH = '/purchase-nft';
export const PURCHASE_NFT_SIGN_PATH = '/purchase-nft/:deploy_hash';
export const ANALYTICS_PATH = '/analytics';
export const ADVERTISE_WITH_US_PATH = '/advertise-with-us';

export type RouterPathsMap = {
  [DELEGATE_STAKE_PATH]: {
    urlParams: undefined;
    queryParams: { validatorPublicKey: string };
  };
  [UNDELEGATE_STAKE_PATH]: {
    urlParams: undefined;
    queryParams: { validatorPublicKey: string };
  };
  [TRANSFER_CSPR_PATH]: {
    urlParams: undefined;
    queryParams: {
      recipient: string;
      amount: string;
      transfer_id: string;
    };
  };
  [DEPLOY_DETAILS_PATH]: {
    urlParams: { id: string };
    queryParams: undefined;
  };
  [TRANSACTION_DETAILS_PATH]: {
    urlParams: { id: string };
    queryParams: undefined;
  };
  [BLOCK_DETAILS_PATH]: {
    urlParams: { id: string };
    queryParams: undefined;
  };
  [ACCOUNT_DETAILS_PATH]: {
    urlParams: { id: string };
    queryParams: undefined;
  };
  [BLOCK_LIST_PATH]: {
    urlParams: undefined;
    queryParams: undefined;
  };
  [VALIDATOR_LIST_PATH]: {
    urlParams: undefined;
    queryParams: undefined;
  };
  [VALIDATOR_DETAILS_PATH]: {
    urlParams: { id: string };
    queryParams: undefined;
  };
  [SEARCH_PATH]: {
    urlParams: { id: string };
    queryParams: undefined;
  };
  [CONTRACT_PATH]: {
    urlParams: { id: string };
    queryParams: undefined;
  };
  [CONTRACT_PACKAGE_PATH]: {
    urlParams: { id: string };
    queryParams: undefined;
  };
  [UREF_PATH]: {
    urlParams: { id: string };
    queryParams: undefined;
  };
  [DICTIONARY_PATH]: {
    urlParams: { id: string };
    queryParams: { dictionary_key: string } | undefined;
  };
  [CONTRACT_LIST_PATH]: {
    urlParams: undefined;
    queryParams: undefined;
  };
  [ACCOUNTS_LIST_PATH]: {
    urlParams: undefined;
    queryParams: undefined;
  };
  [NFT_TOKEN_PATH]: {
    urlParams: { contract_package_hash: string; token_id: string };
    queryParams: undefined;
  };
  [ACTIVITY_EXPORT_PATH]: {
    urlParams: undefined;
    queryParams: undefined;
  };
  [PURCHASE_NFT_PATH]: {
    urlParams: undefined;
    queryParams: undefined;
  };
  [ACTIVITY_EXPORT_ONBOARDING_PATH]: {
    urlParams: undefined;
    queryParams: undefined;
  };
  [ACTIVITY_EXPORT_LEARN_MORE_PATH]: {
    urlParams: undefined;
    queryParams: undefined;
  };
  [ANALYTICS_PATH]: {
    urlParams: undefined;
    queryParams: undefined;
  };
  [ASSOCIATED_KEYS_ONBOARDING_PATH]: {
    urlParams: undefined;
    queryParams: undefined;
  };
  [ASSOCIATED_KEYS_PATH]: {
    urlParams: undefined;
    queryParams: undefined;
  };
  [MANAGE_ASSOCIATED_KEYS_PATH]: {
    urlParams: undefined;
    queryParams: undefined;
  };
  [ASSOCIATED_KEYS_LEARN_MORE_PATH]: {
    urlParams: undefined;
    queryParams: undefined;
  };
  [DELEGATE_STAKE_SIGN_PATH]: {
    urlParams: { deploy_hash: string };
    queryParams: undefined;
  };
  [UNDELEGATE_STAKE_SIGN_PATH]: {
    urlParams: { deploy_hash: string };
    queryParams: undefined;
  };
  [TRANSFER_CSPR_SIGN_PATH]: {
    urlParams: { deploy_hash: string };
    queryParams: undefined;
  };
  [ACTIVITY_EXPORT_SIGN_PATH]: {
    urlParams: { deploy_hash: string };
    queryParams: undefined;
  };
  [PURCHASE_NFT_SIGN_PATH]: {
    urlParams: { deploy_hash: string };
    queryParams: undefined;
  };
  [MANAGE_ASSOCIATED_KEYS_SIGN_PATH]: {
    urlParams: { deploy_hash: string };
    queryParams: undefined;
  };
  [ADVERTISE_WITH_US_PATH]: {
    urlParams: undefined;
    queryParams: undefined;
  };
  [BUY_CSPR_PATH]: {
    urlParams: undefined;
    queryParams: undefined;
  };
};

export const routePatternsList = [
  HOME_PATH,
  BUY_CSPR_PATH,
  ACCOUNT_DETAILS_PATH,
  CREATE_ACCOUNT_PATH,
  SEARCH_PATH,
  CONTRACT_PATH,
  NFT_TOKEN_PATH,
  CONTRACT_PACKAGE_PATH,
  BLOCK_LIST_PATH,
  BLOCK_DETAILS_PATH,
  VALIDATOR_LIST_PATH,
  VALIDATOR_AUCTION_PATH,
  VALIDATOR_DETAILS_PATH,
  DEPLOY_LIST_PATH,
  DEPLOY_DETAILS_PATH,
  TRANSACTION_LIST_PATH,
  TRANSACTION_DETAILS_PATH,
  FAUCET_PATH,
  PEERS_PATH,
  PROFILE_PATH,
  VIEW_ADDRESS_PATH,
  DEVELOPER_TOOLS_PATH,
  TOS_PATH,
  PRIVACY_POLICY_PATH,
  CHANGELOG_PATH,
  CREDITS_PATH,
  DELEGATE_STAKE_PATH,
  DELEGATE_STAKE_SIGN_PATH,
  UNDELEGATE_STAKE_SIGN_PATH,
  TRANSFER_CSPR_PATH,
  TRANSFER_CSPR_SIGN_PATH,
  UREF_PATH,
  DICTIONARY_PATH,
  ACCOUNTS_LIST_PATH,
  CONTRACT_LIST_PATH,
  ACTIVITY_EXPORT_PATH,
  ACTIVITY_EXPORT_SIGN_PATH,
  ASSOCIATED_KEYS_ONBOARDING_PATH,
  ASSOCIATED_KEYS_PATH,
  MANAGE_ASSOCIATED_KEYS_PATH,
  MANAGE_ASSOCIATED_KEYS_SIGN_PATH,
  ASSOCIATED_KEYS_LEARN_MORE_PATH,
  PURCHASE_NFT_PATH,
  PURCHASE_NFT_SIGN_PATH,
  ACTIVITY_EXPORT_ONBOARDING_PATH,
  ACTIVITY_EXPORT_LEARN_MORE_PATH,
  ANALYTICS_PATH,
  ADVERTISE_WITH_US_PATH,
  UNDELEGATE_STAKE_PATH,
];
